import {DialogProps, IClubForm} from 'packages/common-types/base-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Button} from '@material-ui/core';
import {FormProvider, useForm} from 'react-hook-form';
import useClub from 'packages/hooks/use-club';
import ClubForm from './new-club/Form';

type Props = DialogProps & {
  clubId: string;
};

const UpdateClub = (props: Props) => {
  const {modalOpen, toggle, clubId} = props;
  const {loading: creatingClub, onUpdateSubmit} = useClub(clubId);
  const methods = useForm<IClubForm>({
    mode: 'onBlur',
  });

  return (
    <>
      <FormProvider {...methods}>
        <Dialog
          open={modalOpen}
          onClose={toggle}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Actualizar un club</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Escribe el nuevo nombre del club
            </DialogContentText>
            <ClubForm submitting={creatingClub} onSubmit={onUpdateSubmit} />
          </DialogContent>
          <DialogActions>
            <Button onClick={toggle} color="primary">
              Cancelar
            </Button>
            <Button
              form="create-club-form"
              type="submit"
              color="primary"
              onClick={toggle}
            >
              Actualizar club
            </Button>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default UpdateClub;
